import { render, staticRenderFns } from "./MoleculeVamosPaLaCalleRanking.vue?vue&type=template&id=3c2f5f47&scoped=true"
import script from "./MoleculeVamosPaLaCalleRanking.vue?vue&type=script&setup=true&lang=js"
export * from "./MoleculeVamosPaLaCalleRanking.vue?vue&type=script&setup=true&lang=js"
import style0 from "./MoleculeVamosPaLaCalleRanking.vue?vue&type=style&index=0&id=3c2f5f47&prod&scoped=true&lang=postcss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c2f5f47",
  null
  
)

export default component.exports